import React, { useState } from 'react';
import { Send, CheckCircle } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    company: '',
    email: '',
    phone: '',
    message: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage('');
    
    try {
      const response = await axios.post(`${API}/contact`, formData);
      
      if (response.data.success) {
        setIsSuccess(true);
        setFormData({
          firstName: '',
          lastName: '',
          company: '',
          email: '',
          phone: '',
          message: ''
        });
        
        // Reset success message after 10 seconds
        setTimeout(() => {
          setIsSuccess(false);
        }, 10000);
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setErrorMessage(
        error.response?.data?.detail || 
        'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="section-container">
        <h2 className="section-title">Lassen Sie uns Ihre Prozesse optimieren.</h2>
        
        <div className="contact-content">
          <div className="contact-info">
            <h3 className="contact-info-title">Kostenloses Erstgespräch</h3>
            <p className="contact-info-text">
              Füllen Sie das Formular aus und wir melden uns innerhalb von 24 Stunden bei Ihnen, 
              um Ihre Dokumenten-Automatisierung zu besprechen.
            </p>
            
            <div className="contact-benefits">
              <div className="benefit-item">
                <CheckCircle size={20} />
                <span>Unverbindliche Beratung</span>
              </div>
              <div className="benefit-item">
                <CheckCircle size={20} />
                <span>Individuelle Prozessanalyse</span>
              </div>
              <div className="benefit-item">
                <CheckCircle size={20} />
                <span>Massgeschneiderte Lösungsvorschläge</span>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            {isSuccess ? (
              <div className="success-message">
                <CheckCircle size={60} />
                <h3>Vielen Dank!</h3>
                <p>Ihre Anfrage wurde erfolgreich gesendet. Wir melden uns innerhalb von 24 Stunden bei Ihnen.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                {errorMessage && (
                  <div className="error-message">
                    {errorMessage}
                  </div>
                )}
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="firstName">Vorname *</label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                      placeholder="Max"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="lastName">Nachname *</label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                      placeholder="Muster"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="company">Unternehmen *</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    required
                    placeholder="Ihr Unternehmen AG"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">E-Mail *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="max.muster@unternehmen.ch"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="phone">Telefonnummer</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+41 XX XXX XX XX"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Nachricht</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="5"
                    placeholder="Beschreiben Sie kurz Ihre Dokumenten-Prozesse und Anforderungen..."
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className="btn-primary contact-submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Wird gesendet...' : 'Kostenloses Erstgespräch anfragen'}
                  {!isSubmitting && <Send size={20} />}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
